import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { PersistGate } from 'redux-persist/lib/integration/react';
import ScrollButton from './components/scrollButton';
import './index.css';
import { persistor, store } from './redux/store';
import AppRouter from './Router';

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <AppRouter />
      <ScrollButton></ScrollButton>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);
